import { render, staticRenderFns } from "./PresubXsaleFooterComponent.vue?vue&type=template&id=791f6bd4"
import script from "./PresubXsaleFooterComponent.vue?vue&type=script&lang=ts"
export * from "./PresubXsaleFooterComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports